const DescriptionBanner = ({ title, description }) => {
  return (
    <section className={`bg-primary py-16 lg:py-28`}>
      <div
        className={
          "container flex flex-col justify-center items-center text-center"
        }
      >
        <h2 aria-level={2} className="text-white max-w-[52.625rem]">
          {title}
        </h2>
        {description ? (
          <div className="max-w-[50rem] my-4 mx-auto">
            {typeof description === "string" ? (
              <p className="max-w-[50rem] mt-4 text-white">{description}</p>
            ) : (
              description
            )}
          </div>
        ) : (
          ""
        )}
      </div>
    </section>
  );
};
export default DescriptionBanner;
